<template>
    <div>
      <!-- Maintenance Request Modal -->
      <transition name="modal" appear>
        <div v-if="isOpen" class="modal-overlay" @click="handleOverlayClick" role="dialog" aria-modal="true"
          aria-labelledby="modal-title">
          <div class="modal-sheet" @click.stop role="document">
            <!-- Modal Header -->
            <header class="modal-header">
              <h2 id="modal-title" class="modal-title">Maintenance Request</h2>
              <button @click="closeModal" class="modal-close" type="button" aria-label="Close maintenance request modal">
                <svg class="close-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                </svg>
              </button>
            </header>
  
            <!-- Modal Content -->
            <form @submit.prevent="submitMaintenanceRequest()" class="modal-form">
              <!-- Title Field -->
              <div class="form-field">
                <label for="maintenance-title" class="field-label">
                  Maintenance Title <span class="required-mark">*</span>
                </label>
                <!-- requestform -->
                <input id="maintenance-title" v-model="form.title" type="text" placeholder="Enter maintenance title"
                  class="field-input" :class="{ 'field-error': errors.title }" required aria-describedby="title-error">
                <p v-if="errors.title" id="title-error" class="error-message" role="alert">
                  {{ errors.title }}
                </p>
              </div>
  
              <!-- Select Property Accordion -->
              <div class="accordion-section">
                <button type="button" @click="toggleAccordion('property')" class="accordion-trigger"
                  :aria-expanded="accordionOpen.property.toString()" aria-controls="property-content">
                  <span class="accordion-title">Select Property</span>
                  <svg class="accordion-chevron" :class="{ 'accordion-chevron-open': accordionOpen.property }" fill="none"
                    stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                  </svg>
                </button>
  
                <div v-show="accordionOpen.property" id="property-content" class="accordion-content">
                  <!-- <div class="form-field">
                    <label for="location-select" class="field-label">Select Location</label>
                    <select id="location-select" v-model="form.location" class="field-input"
                      :class="{ 'field-error': errors.location }" required aria-describedby="location-error">
                      <option value="">Select Location</option>
                      <option value="abuja">22 Gana street, FHA Karu, Abuja.</option>
                    </select>
                    <p v-if="errors.location" id="location-error" class="error-message" role="alert">
                      {{ errors.location }}
                    </p>
                  </div>
  
                  <div class="form-field">
                    <label for="property-select" class="field-label">Select Property</label>
                    <select id="property-select" v-model="form.property" class="field-input"
                      :class="{ 'field-error': errors.property }" required aria-describedby="property-error">
                      <option value="">Select Property</option>
                      <option value="garnet-apartments">Garnet Apartments</option>
                    </select>
                    <p v-if="errors.property" id="property-error" class="error-message" role="alert">
                      {{ errors.property }}
                    </p>
                  </div> -->
  
                  <!-- Units Selection (1st)-->
                  <div class="units-selection">
                    <div class="units-header">
                      <span class="field-label">
                        Select Units <span class="required-mark">*</span>
                      </span>
                      <!-- <button type="button" @click="toggleAllUnits('selectedUnits')" class="toggle-units-btn">
                        {{ allUnitsSelected('selectedUnits') ? 'Deselect All' : 'Select All' }}
                      </button> -->
                    </div>
  
                    <div class="units-grid" role="group" aria-labelledby="units-label">
                      <label v-for="unit in propertyData" :key="unit.id" class="unit-option">
                        <input type="checkbox" :value="unit.nomenclature_serial" v-model="form.selectedUnits" class="unit-checkbox">
                        <span class="unit-label">{{ unit.nomenclature_serial || "No unit name found" }}</span>
                      </label>
                    </div>
  
                    <p v-if="errors.selectedUnits" class="error-message" role="alert">
                      {{ errors.selectedUnits }}
                    </p>
                  </div>
                </div>
              </div>
  
              <!-- Request Details Accordion -->
              <div class="accordion-section">
                <button type="button" @click="toggleAccordion('details')" class="accordion-trigger"
                  :aria-expanded="accordionOpen.details.toString()" aria-controls="details-content">
                  <span class="accordion-title">Request Details</span>
                  <svg class="accordion-chevron" :class="{ 'accordion-chevron-open': accordionOpen.details }" fill="none"
                    stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                  </svg>
                </button>
  
                <div v-show="accordionOpen.details" id="details-content" class="accordion-content">
                  <!-- Category -->
                  <div class="form-field">
                    <label for="category-select" class="field-label">
                      Maintenance Category <span class="required-mark">*</span>
                    </label>
                    <select id="category-select" v-model="form.category" class="field-input"
                      :class="{ 'field-error': errors.category }" required aria-describedby="category-error">
                      <option disabled value=""> Select Category </option>
  
                      <option v-for="item in form.categories" :key="item.id" :value="item.id">
                        {{ item.name }}
                      </option>
                    </select>
  
                    <p v-if="errors.category" id="category-error" class="error-message" role="alert">
                      {{ errors.category }}
                    </p>
                  </div>
  
                  <!-- Priority -->
                  <fieldset class="form-field">
                    <legend class="field-label">
                      Priority <span class="required-mark">*</span>
                    </legend>
                    <div class="radio-group" role="radiogroup">
                      <label v-for="priority in priorities" :key="priority.value" class="radio-option">
                        <input type="radio" :value="priority.value" v-model="form.priority" class="radio-input"
                          :name="`priority-${_uid}`">
                        <span class="radio-label">{{ priority.label }}</span>
                      </label>
                    </div>
                    <p v-if="errors.priority" class="error-message" role="alert">
                      {{ errors.priority }}
                    </p>
                  </fieldset>
  
                  <!-- Facilities Affected -->
                  <div class="units-selection">
                    <div class="units-header">
                      <span class="field-label">
                        Facilities Affected <span class="required-mark">*</span>
                      </span>
                      <!-- <button type="button" @click="toggleAllUnits('facilitiesAffected')" class="toggle-units-btn">
                        {{ allUnitsSelected('facilitiesAffected') ? 'Deselect All' : 'Select All' }}
                      </button> -->
                    </div>
  
                    <div class="units-grid" role="group" aria-labelledby="facilities-label">
                      <!-- <div v-for="(unit, index) in unitsWithFacilities" :key="index"> -->
                        <label v-for="(facility, fIndex) in facilities" :key="fIndex" class="unit-option">
                          <input type="checkbox" :value="facility" v-model="form.facilitiesAffected"
                            class="unit-checkbox">
                          <span class="unit-label">
                            {{ facility.toUpperCase() }}
                          </span>
                        </label>
                      <!-- </div> -->
                    </div>
  
                    <p v-if="errors.facilitiesAffected" class="error-message" role="alert">
                      {{ errors.facilitiesAffected }}
                    </p>
                  </div>
  
                  <!-- Description -->
                  <div class="form-field">
                    <label for="description-field" class="field-label">
                      Describe the Issue <span class="required-mark">*</span>
                    </label>
                    <textarea id="description-field" v-model="form.description" rows="4"
                      placeholder="Please provide more details about the issue..." class="field-textarea"
                      :class="{ 'field-error': errors.description }" required
                      aria-describedby="description-error"></textarea>
                    <p v-if="errors.description" id="description-error" class="error-message" role="alert">
                      {{ errors.description }}
                    </p>
                  </div>
                </div>
              </div>
  
              <!-- File Upload -->
              <div class="form-field">
                <label class="field-label">Upload Images/Videos</label>
  
                <div class="upload-zone" @dragover.prevent="handleDragOver" @dragleave.prevent="handleDragLeave"
                  @drop.prevent="handleFileDrop" :class="{ 'upload-zone-dragover': isDragOver }">
                  <input ref="fileInput" type="file" multiple accept="image/*,video/*" @change="validateFile"
                    class="upload-input" aria-label="Upload files">
  
                  <button :disabled="isLoading" type="button" @click="$refs.fileInput.click()" class="upload-button">
                    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M18 13V16.3333C18 16.7754 17.8244 17.1993 17.5118 17.5118C17.1993 17.8244 16.7754 18 16.3333 18H4.66667C4.22464 18 3.80072 17.8244 3.48816 17.5118C3.17559 17.1993 3 16.7754 3 16.3333V13"
                        stroke="white" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M14.6693 7.16667L10.5026 3L6.33594 7.16667" stroke="white" stroke-width="1.6"
                        stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M10.5 3V13" stroke="white" stroke-width="1.6" stroke-linecap="round"
                        stroke-linejoin="round" />
                    </svg>
  
                    <!-- Upload -->
                    {{ isLoading ? 'Uploading...' : 'Upload' }}
                  </button>
  
                  <p class="upload-text">Choose Images to upload</p>
                  <p class="upload-hint">Max 5 files. Images (JPG, PNG). Max Size: 5MB</p>
                  <p class="upload-hint">Upload one at a time</p>
                </div>
  
                <!-- File List -->
                <div class="file-list">
                  <div class="row">
                    <div class="col-md-6" v-for="(item, index) in displayedFiles" :key="index">
                        <div class="file-item">
                            <div class="file-info w-100">
                                <div class="file-icon">
                                    <img class="uploaded-img" :src="item.url" alt="image">
                                </div>
                                <div class="file-details">
                                    <p class="file-name ellipsis2">{{ item.filename }}</p>
                                    <p class="file-size">{{item.size.toFixed(2)}}MB</p>
                                </div>
                                <div class="file-actions">
                                    <button type="button" @click="removeImage(index)"
                                    class="file-remove" :aria-label="`Remove`">
            
            
                                    <svg class="remove-icon" width="16" height="16" viewBox="0 0 16 16" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <rect width="16" height="16" rx="4" fill="#FB3748" fill-opacity="0.1" />
                                        <path d="M12 4L4 12" stroke="#FB3748" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                        <path d="M4 4L12 12" stroke="#FB3748" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    </svg>
            
                                    </button>
            
            
                                </div>
                            </div>
                        

                            <!-- Progress Bar -->
                            <!-- <div class="progress-container">
                            <div class="progress-bar" :style="{ width: file.progress + '%' }" role="progressbar"
                                :aria-valuenow="file.progress" aria-valuemin="0" aria-valuemax="100"></div>
                            </div> -->
                        </div>
                    </div>
                  </div>
                </div>
              </div>
  
  
  
              <!-- Notes -->
              <div class="form-field">
                <label for="notes-field" class="field-label">Notes <span class="optional-mark">(optional)</span></label>
                <textarea id="notes-field" v-model="form.notes" rows="3" placeholder="Enter additional note here"
                  class="field-textarea"></textarea>
              </div>
  
              <!-- Form Actions -->
              <div class="form-actions">
                <button type="button" @click="closeModal" class="btn btn-secondary" :disabled="isSubmitting">
                  Cancel
                </button>
                <button type="submit" class="btn" :disabled="isSubmitting">
                  <svg v-if="isSubmitting" class="loading-spinner" fill="none" viewBox="0 0 24 24">
                    <circle class="spinner-track" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="spinner-path" fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                    </path>
                  </svg>
                  {{ isSubmitting ? 'Submitting...' : 'Submit Request' }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </transition>
  
      <!-- Vendor Assignment Modal -->
      <transition name="modal" appear>
        <div v-if="isVendorModalOpen" class="modal-overlay" @click="closeVendorModal" role="dialog" aria-modal="true"
          aria-labelledby="vendor-modal-title">
          <div class="modal-sheet" @click.stop role="document">
            <!-- Vendor Modal Header -->
            <header class="modal-header">
              <h2 id="vendor-modal-title" class="modal-title">Assign a Vendor</h2>
              <button @click="closeVendorModal" class="modal-close" type="button" aria-label="Close vendor modal">
                <svg class="close-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                </svg>
              </button>
            </header>
  
            <!-- Request Summary -->
            <div class="request-summary vendor-request-summary my-3 p-3  rounded">
              <p><strong v-if="requestSuccessful.data.serial">Request ID:</strong> {{requestSuccessful.data.serial}}</p>
              <p><strong requestSuccessful.property>Property:</strong> {{requestSuccessful.property.title}}</p>
              <!-- <p><strong>Issue:</strong> {{ form.title || 'No title ' }}</p> -->
              <p v-if="requestSuccessful.data.maintenance_category"><strong>Category:</strong> {{  requestSuccessful.data.maintenance_category.name || 'No Category' }}</p>
            </div>
  
            <!-- Search Vendor Accordion -->
            <div class="accordion-section mt-2 mb-4">
              <button type="button" @click="toggleAccordion('searchVendor')" class="accordion-trigger"
                :aria-expanded="accordionOpen.searchVendor.toString()" aria-controls="search-vendor-content">
                <span class="accordion-title">Search Vendor</span>
                <svg class="accordion-chevron" :class="{ 'accordion-chevron-open': accordionOpen.searchVendor }"
                  fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                </svg>
              </button>
              <hr>
  
              <div v-show="accordionOpen.searchVendor" id="search-vendor-content" class="accordion-content">
                <div class="form-field">
                  <label for="vendor-location-select" class="field-label">Select Location(optional)</label>
                  <select id="vendor-location-select" v-model="vendorSearch.location" class="field-input">
                    <option value="" selected disabled>Select location</option>
                    <option value="">None</option>
                    <option v-for="item in locationList" :key="item.id" :value="item.id">{{ item.name }}</option>
                    <!-- <option value="ikeja">Ikeja</option>
                    <option value="victoria-island">Victoria Island</option>
                    <option value="lekki">Lekki</option> -->
                  </select>
                </div>
                <div class="form-field">
                  <label for="vendor-category-select" class="field-label">Select Category</label>
                  <select id="vendor-category-select" v-model="vendorSearch.category" class="field-input">
                    <option value="" selected disabled>Select category</option>
                    <option v-for="item in form.categories" :key="item.id" :value="item.id" >{{item.name}}</option>
                    <!-- <option value="electrical">Electrical</option>
                    <option value="hvac">HVAC</option> -->
                  </select>
                </div>
              </div>
            </div>
  
            <!-- Vendor Modal Content -->
            <div class="modal-content">
              <!-- Available Vendors -->
              <section class="vendors-section">
                <h3 class="section-title">Available Vendors <span class="ml-3" v-if="loadingVendors"><i class="fa fa-spinner fa-spin"></i></span></h3>
                <div class="vendors-list">
                  <div v-for="vendor in vendorList" :key="vendor.id" class="vendor-card"
                    :class="{ 'vendor-selected': selectedVendors.includes(vendor.id) }"
                    role="button" tabindex="0"
                    @keydown.enter="toggleVendorSelection(vendor.id)"
                    @keydown.space.prevent="toggleVendorSelection(vendor.id)">
                    <div class="vendor-content">
                      <div class="vendor-header">
                        <input type="checkbox" :checked="selectedVendors.includes(vendor.id)"
                          @change="toggleVendorSelection(vendor.id)" @click.stop class="vendor-checkbox"
                          :aria-label="`Select ${vendor.user.firstname}`">
                        <div class="d-flex align-items-center gap-1">
                          <h4 v-if="vendor.user" class="vendor-name">{{ vendor.user.firstname }} {{ vendor.user.lastname }}</h4>
  
                          <span class="vendor-status"><svg style="width: 16px; height: 16px;" width="8" height="9" viewBox="0 0 8 9" fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <circle cx="4" cy="4.5" r="3" fill="#17B26A" />
                            </svg>
                            Available</span>
                        </div>
  
                      </div>
  
                      <div class="vendor-details">
                        <div class="vendor-detail" v-if="vendor.city">
  
  
                          <svg class="detail-icon" width="14" height="14" viewBox="0 0 14 14" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_9137_221801)">
                              <path
                                d="M7 13.4154C7 13.4154 12.25 9.91537 12.25 5.83203C12.25 4.43965 11.6969 3.10429 10.7123 2.11972C9.72774 1.13515 8.39239 0.582031 7 0.582031C5.60761 0.582031 4.27226 1.13515 3.28769 2.11972C2.30312 3.10429 1.75 4.43965 1.75 5.83203C1.75 9.91537 7 13.4154 7 13.4154Z"
                                stroke="#717680" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                              <path
                                d="M7 7.58203C7.9665 7.58203 8.75 6.79853 8.75 5.83203C8.75 4.86553 7.9665 4.08203 7 4.08203C6.0335 4.08203 5.25 4.86553 5.25 5.83203C5.25 6.79853 6.0335 7.58203 7 7.58203Z"
                                stroke="#717680" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                            <defs>
                              <clipPath id="clip0_9137_221801">
                                <rect width="14" height="14" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
  
                          {{ vendor.city.name }}
                        </div>
  
                        <div class="vendor-detail">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M13.3359 4.66797H2.66927C1.93289 4.66797 1.33594 5.26492 1.33594 6.0013V12.668C1.33594 13.4043 1.93289 14.0013 2.66927 14.0013H13.3359C14.0723 14.0013 14.6693 13.4043 14.6693 12.668V6.0013C14.6693 5.26492 14.0723 4.66797 13.3359 4.66797Z"
                              stroke="#717680" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path
                              d="M10.6693 14V3.33333C10.6693 2.97971 10.5288 2.64057 10.2787 2.39052C10.0287 2.14048 9.68956 2 9.33594 2H6.66927C6.31565 2 5.97651 2.14048 5.72646 2.39052C5.47641 2.64057 5.33594 2.97971 5.33594 3.33333V14"
                              stroke="#717680" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
  
                          {{filteredCategory[0].name}} ({{ vendor.jobs }})
                        </div>
                      </div>
  
                      <button class="btn btn-secondary mt-3" type="button">
                        View Profile
                      </button>
                    </div>
                  </div>
                  <h4 v-if="vendorList.length == 0 && vendorSearch.category != ''" class="no-vendor">No vendor found</h4>
                </div>
              </section>
  
  
            </div>
  
            <!-- DATE/TIME CONTAINER -->
            <div class="inspection-date-time-container my-4">
              <div class="date-time-group">
                <div class="form-field">
                  <label for="inspection-date" class="field-label">Preferred Inspection Date</label>
                  <div class="date-input-wrapper">
                    <svg class="calendar-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z">
                      </path>
                    </svg>
                    <input id="inspection-date" v-model="displayDate" :min="minDate" type="text" placeholder="DD-MM-YYYY"
                      class="field-input date-input" @focus="showNativeDatePicker" @blur="hideNativeDatePicker">
                  </div>
                </div>
                <div class="form-field">
                  <label for="inspection-date" class="field-label">Preferred Inspection Time</label>
                  <div class="date-input-wrapper">
                    <svg class="calendar-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z">
                      </path>
                    </svg>
                    <input id="inspection-date" v-model="displayTime" type="time" placeholder="Times"
                      class="field-input date-input">
                  </div>
                </div>
                <!-- <div class="form-field d-none">
                  <label for="inspection-time" class="field-label">Preferred Inspection Time</label>
                  <div class="time-input-group">
                    <div class="field-input time-display-input" :class="{ 'time-input-active': isTimeDropdownOpen }"
                      @click="toggleTimeDropdown" tabindex="0" role="combobox" aria-haspopup="listbox"
                      :aria-expanded="isTimeDropdownOpen.toString()" aria-controls="time-options-list">
                      {{ displayTime }}
                    </div>
                    <div class="time-ampm-buttons">
                      <button type="button" class="ampm-button"
                        :class="{ 'ampm-button-active': preferredInspectionTimeAmPm === 'AM' }"
                        @click="setPreferredTimeAmPm('AM')">AM</button>
                      <button type="button" class="ampm-button"
                        :class="{ 'ampm-button-active': preferredInspectionTimeAmPm === 'PM' }"
                        @click="setPreferredTimeAmPm('PM')">PM</button>
                    </div>
  
                    <ul v-if="isTimeDropdownOpen" id="time-options-list" class="time-dropdown" role="listbox">
                      <li v-for="timeOption in timeOptions" :key="timeOption.value" class="time-dropdown-item"
                        :class="{ 'time-dropdown-item-active': timeOption.value === preferredInspectionTime }"
                        @click="selectTime(timeOption.value)" role="option"
                        :aria-selected="timeOption.value === preferredInspectionTime">
                        {{ timeOption.display }}
                      </li>
                    </ul>
                  </div>
                </div> -->
              </div>
            </div>
  
            <!-- Notes -->
            <div class="form-field">
              <label for="notes-field" class="field-label">Notes <span class="optional-mark">(optional)</span></label>
              <textarea id="notes-field" v-model="noteVendor" rows="3" placeholder="Enter additional note here"
                class="field-textarea"></textarea>
            </div>
  
  
            <!-- Vendor Actions -->
            <div class="form-actions">
              <button type="button" @click="closeVendorModal" class="btn btn-secondary">
                Cancel
              </button>
              <button type="button" @click="assignVendor()" class="btn " :disabled="assigningLoader">
                Assign {{ selectedVendors.length > 0 ? `${selectedVendors.length} ` : '' }}Vendor
                <span v-if="assigningLoader" class=" pl-3"><i class="fa fa-spinner spin"></i></span>
              </button>
            </div>
          </div>
        </div>
      </transition>
  
      <!-- SUCCESS MODAL -->
      <div class="modal fade" id="successModal" tabindex="-1" aria-labelledby="cancelModalLabel" aria-hidden="true">
        <div class="modal-dialog ">
          <div class="modal-content">
  
  
            <div class="text-center py-5">
              <div>
                <img src="@/assets/icons/green-check-circle.png" alt="">
  
              </div>
  
              <h2 class="text-center font-weight-bold" style="color: #2B3352;">
                Request Successful </h2>
              <p class="modal-description" style="color: #555C74;">Your maintenance request has been logged</p>
            </div>
            <!-- Request Summary -->
            <div class="request-summary py-3 px-4 rounded">
              <p v-if="requestSuccessful.data">Request ID: {{requestSuccessful.data.serial}}</p>
              <p v-if="requestSuccessful.property">Property: {{requestSuccessful.property.title}}</p>
              <p v-if="requestSuccessful.data.maintenance_category">Category: {{ requestSuccessful.data.maintenance_category.name || 'No category selected' }}</p>
            </div>
            <div class="w-full mt-4 d-flex justify-content-between align-items-center gap-2 pb-5">
              <button class="btn btn-secondary w-50" data-dismiss="modal">
                Cancel
              </button>
              <button class="btn w-50" @click="openVendorModal()" data-dismiss="modal">
                Assign Vendor
              </button>
            </div>
          </div>
        </div>
      </div>
  
      <!-- ERROR MODAL -->
      <div class="modal fade" id="errorModal" tabindex="-1" aria-labelledby="cancelModalLabel" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="errorModalLabel">
              </h5>
  
            </div>
  
            <div class="modal-body text-center">
              <div>
                <img src="@/assets/icons/warning.png" alt="">
  
              </div>
  
              <h2 class="font-weight-bold" style="color: #2B3352;">
                Request Not Submitted
              </h2>
              <p class="modal-description" style="color: #555C74;">There was a problem submitting your request</p>
            </div>
            <div class="w-full my-4">
              <button class="btn w-full btn-block" data-dismiss="modal">
                Try Again
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  
  
  </template>
  
  <script>
  import $ from "jquery";
  import maintenanceRequests from "../services/maintenanceRequest";
  import properties from "../services/properties";
//   import partners from "../services/partners";
  export default {
    name: 'MaintenanceRequestModal',
    props: {
      isOpen: {
        type: Boolean,
        default: false
      },
      propertyData: []
    },
    data() {
      return {
        // Modal states
        isVendorModalOpen: false,
        isSubmitting: false,
        isDragOver: false,
        isLoading: false,
        loadingVendors: false,
        assigningLoader: false,
        // Accordion states
        accordionOpen: {
          property: true,
          details: true,
          inspection: true,
          searchVendor: true,
          vendorInspection: true
        },

        // requestform: {
        //     titile: "",
        //     units: [],
        //     category: "",
        //     priority: "",
        //     facilities: "",
        //     description: "",
        //     images: [],
        //     notes: "",
        // },
  
  
        // Form data for Maintenance Request
        form: {
          title: '',
          location: '',
          property: '',
          uploadedImage: "",
          workSampleFile: "",
          workSampleFileName: "",
          selectedUnits: [],
          categories: [],
          category: '',
          priority: '',
          property_batch: '',
          description: '',
          facilitiesAffected: [],
          isInspectionRequired: '',
          preferredInspectionDate: '',
          preferredInspectionTime: '',
          preferredInspectionTimeAmPm: 'AM',
          notes: ''
        },
  
        // Form data for Vendor Assignment
        vendorForm: {
          date: '',
          time: '',
          ampm: 'AM',
          notes: ''
        },
  
        // Validation errors
        errors: {},
  
        // File handling
        uploadedFiles: [],
        imagesUrl: [],
        displayedFiles: [],
        imagesUrl2: [
          "www.cha.com",
          "www.deb.com",
          "www.iso.com",
          "www.ron.com",
        ],
        displayedFiles2: [
          {filename: "cha", url: 'www.ca.com', size:2},
          {filename: "deb", url: 'www.deb.com', size:1},
          {filename: "iso", url: 'www.iso.com', size:2},
          {filename: "ron", url: 'www.ron.com', size:2},
        ],
        // Vendor selection
        selectedVendors: [],
  
        // Vendor search filters
        vendorSearch: {
          location: '',
          category: ''
        },
        preferredInspectionDate: '', // Stores YYYY-MM-DD format
        displayDate: '',
        displayTime: "",
        preferredInspectionTime: '18:00', // Default to 6 PM (24-hour format)
        preferredInspectionTimeAmPm: 'PM', // Default to PM
        isTimeDropdownOpen: false,
        timeOptions: [],
        requestSuccessful: {
            data: {},
            property: {}
        },
  
        units: [],
        batch: "",
        facilities: [],
        priorities: [
          { value: 'low', label: 'Low' },
          { value: 'medium', label: 'Medium' },
          { value: 'high', label: 'High' },
          { value: 'critical', label: 'Critical' } // Updated label
        ],
        // availableVendors: [
        //   { id: 1, name: 'FixRight Plumbing Co.', location: 'Ikeja', totalJobs: '23 jobs', category: 'plumbing' },
        //   { id: 2, name: 'AquaFix Solutions', location: 'Victoria Island', totalJobs: '12 jobs', category: 'plumbing' },
        //   { id: 3, name: 'ProPlumb Services', location: 'Lekki', totalJobs: '7 jobs', category: 'plumbing' },
        //   { id: 4, name: 'RapidFix Plumbing', location: 'Ikeja', totalJobs: '1 job', category: 'plumbing' }
        // ],
        locationList: [],
        vendorList: [],
        filteredCategory: "",
        user: "",
        noteVendor: "",
        minDate: new Date().toISOString().split('T')[0]
      }
    },
  
    computed: {
      allUnitsSelected() {
        return (field) => {
          return this.form[field].length === this.units.length && this.units.length > 0;
        };
      },
      filteredVendors() {
        return this.availableVendors.filter(vendor => {
          const matchesLocation = this.vendorSearch.location ? vendor.location === this.vendorSearch.location : true;
          const matchesCategory = this.vendorSearch.category ? vendor.category === this.vendorSearch.category : true;
          return matchesLocation && matchesCategory;
        });
      },
    //   displayTime() {
    //     return this.formatTimeForDisplay(this.preferredInspectionTime);
    //   },
      unitsWithFacilities() {
        return this.units.map(unit => {
          let parsedFacilities = []
          try {
            parsedFacilities = JSON.parse(unit.facilities)
          } catch (e) {
            parsedFacilities = []
          }
          return {
            ...unit,
            facilities: parsedFacilities,
          }
        })
      }
  
    },
  
    watch: {
      // Watch for prop changes to manage body scroll
      isOpen(newVal) {
        if (newVal) {
          this.lockBodyScroll();
        } else {
          this.unlockBodyScroll();
        //   this.resetForm(); // Reset form when main modal closes
        }
      },
      isVendorModalOpen(newVal) {
        if (newVal) {
          this.lockBodyScroll();
        } else {
          this.unlockBodyScroll();
        }
      },
      "vendorSearch.category"(newVal) {
        if (newVal) {
            this.searchForVendor();
            this.filteredCategory = this.form.categories.filter(cate => cate.id == this.vendorSearch.category);
        }
      },
    //   requestSuccessful(newVal) {

    //   },
      // Watch for form changes to clear errors
      'form.title'() { this.clearFieldError('title'); },
  
      'form.selectedUnits'() { this.clearFieldError('selectedUnits'); },
      'form.category'() { this.clearFieldError('category'); },
      'form.priority'() { this.clearFieldError('priority'); },
      'form.description'() { this.clearFieldError('description'); },
      'form.facilitiesAffected'() { this.clearFieldError('facilitiesAffected'); },
      'form.isInspectionRequired'() { this.clearFieldError('isInspectionRequired'); },
      'form.preferredInspectionDate'() { this.clearFieldError('preferredInspectionDate'); },
      'form.preferredInspectionTime'() { this.clearFieldError('preferredInspectionTime'); }
    },
    
    created() {
      this.batch = this.$route.params.id;
    },
    mounted() {
        this.user = JSON.parse(localStorage.getItem('shelta-user'));
        // this.generateTimeOptions();
        document.addEventListener('click', this.handleClickOutside);
        this.fetchFacilitiesProperty()
        // this.openVendorModal();
        this.fetchMaintenance();
        this.fetchServicesCategories();
      
    },
    beforeDestroy() {
      document.removeEventListener('click', this.handleClickOutside);
      localStorage.removeItem("maintenanceRequest");
    },
    methods: {
      // Modal management
      closeModal() {
        this.$emit('close');
      },
  
      handleOverlayClick(event) {
        if (event.target === event.currentTarget) {
          this.closeModal();
        }
      },
  
      openVendorModal() {
        this.isVendorModalOpen = true;
      },
  
      closeVendorModal() {
        this.isVendorModalOpen = false;
      },
  
      lockBodyScroll() {
        document.body.style.overflow = 'hidden';
      },
  
      unlockBodyScroll() {
        document.body.style.overflow = '';
      },
  
      toggleAccordion(section) {
        this.$set(this.accordionOpen, section, !this.accordionOpen[section]);
      },
  
      // Unit selection
      toggleAllUnits(field) {
        if (this.allUnitsSelected(field)) {
          this.form[field] = [];
        } else {
          this.form[field] = this.units.map(unit => unit.id);
        }
        this.clearFieldError(field);
      },
  
      // Vendor selection
      toggleVendorSelection(vendorId) {
        const index = this.selectedVendors.indexOf(vendorId);
        if (index > -1) {
          this.selectedVendors.splice(index, 1);
        } else {
          this.selectedVendors.push(vendorId);
        }
      },
  
  
  
      handleDragOver() {
        this.isDragOver = true;
      },
  
      handleDragLeave() {
        this.isDragOver = false;
      },
  
      handleFileDrop(event) {
        this.isDragOver = false;
        const files = Array.from(event.dataTransfer.files);
        this.processFiles(files);
      },
  
      handleFileSelect(event) {
        const files = Array.from(event.target.files);
        this.processFiles(files);
        // Reset input to allow selecting same file again
        event.target.value = '';
      },
  
      processFiles(files) {
        this.validateFile(files);
        // files.forEach(file => {
        //   if (this.uploadedFiles.length >= 5) { // Limit to 5 files
        //     this.$toast.error("Maximum 5 files allowed.");
        //     return;
        //   }
  
        //   if (this.validateFile(file)) {
        //     const fileObj = {
        //       id: `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
        //       name: file.name,
        //       size: file.size,
        //       type: file.type,
        //       progress: 0,
        //       rawFile: file,
        //       serverFileName: null,
        //       url: null
        //     };
  
  
        //     this.uploadedFiles.push(fileObj);
  
        //     // start the real upload
        //     // this.simulateUpload(fileObj);
        //   }
        // });
      },
  
      validateFile(event) {
        this.isLoading = true;
        this.workSampleFile = event.target.files[0];
        // const file = event.target.files[0];
        this.workSampleFileName = this.workSampleFile.name;
  
        if (!this.workSampleFile) {
          this.isLoading = false;
          return this.$toast.error("select a file");
        }
        if (
          this.workSampleFile.type === "application/pdf" ||
          this.workSampleFile.type === "image/jpeg" ||
          this.workSampleFile.type === "image/jpg" ||
          this.workSampleFile.type === "image/png" ||
          this.workSampleFile.type === "image/gif" ||
          this.workSampleFile.type === "application/pdf" ||
          this.workSampleFile.type === "svg+xml"
        ) {
          this.isLoading = true;
        } else {
          this.isLoading = false;
          this.workSampleFile = "";
          return this.$toast.error("Select an appropriate file");
        }
  
        // Handle the uploaded filesize here
        const sizeInMb = this.workSampleFile.size / (1024 * 1024).toFixed(3);
        if (sizeInMb > 5) {
          this.isLoading = false;
          return this.$toast.error("File size more than 5MB");
        }
        let formData = new FormData();
        formData.append("file", this.workSampleFile);
        formData.append("upload_type", "work_samples");
        maintenanceRequests
          .uploadRequestImages(formData)
          .then((res) => {
            // console.log("Uploaded File", res)
            // this.uploadingWorkSamples = false;
            this.isLoading = false;
            if (res.success) {
  
              this.workSampleServerFileName = res.filename;
              let obj = {};
              obj.filename = res.filename;
              obj.url = res.url;
              obj.size = sizeInMb;
              this.displayedFiles.push(obj); 
              this.imagesUrl.push(res.filename);
            
              // console.log("File URL", this.imagesUrl)
              // console.log("File name", this.displayedFiles)
              this.$toast.success("Image upload successful");
            } else {
              this.$toast.error(res.error);
            }
          })
          .catch((err) => {
            console.log(err);
            this.isLoading = false;
          });
  
  
      },
  
      searchForVendor() {
        this.loadingVendors = true;
        let payload = {
            maintainance_id: 1,
            location_id: this.vendorSearch.location,
            service_id: 1,
        }
        // if (if) {}
        try {
            maintenanceRequests.searcheVendors(JSON.stringify(payload)).then(res => {
                this.loadingVendors = false;
                // console.log("Vendors", res);
                if (res.success) {
                    this.vendorList = res.vendors;
                }
                if (res.error) {
                    this.$toast.error(res.error);
                }
            }).catch((err) => {
            this.loadingVendors = false;
            console.log(err);
            // this.$toast.error("please check your network and refresh the page");
          })
        } finally {
            // console.log("closed",)
        }
      },
      fetchMaintenance() {
        let id = JSON.parse(localStorage.getItem("maintenanceRequest"))
        if (id) {
            try {
                maintenanceRequests.fetchMaintenanceById(id.data.id).then(res => {
                    this.locationList = res.locations_for_request;
                    // console.log("Maintenace", res);
                }).catch((err) => {
                    // this.loading = false;
                    console.log(err);
                // this.$toast.error("please check your network and refresh the page");
                })
            } finally {
                // console.log("closed",)
            }
        }
      },
  
    //   simulateUpload(fileObj) {
    //     const formData = new FormData();
    //     formData.append("file", fileObj.rawFile);
    //     formData.append("upload_type", "work_samples");
  
    //     partners.uploadVendorWorkSamples(
    //       formData,
    //       {
    //         onUploadProgress: (event) => {
    //           if (event.lengthComputable) {
    //             fileObj.progress = Math.round((event.loaded / event.total) * 100);
    //           }
    //         }
    //       }
    //     )
    //       .then((res) => {
    //         fileObj.progress = 100;
    //         fileObj.serverFileName = res.filename;
    //         fileObj.url = res.url;
    //         this.$toast.success(res.success);
    //         this.$toast.success("File upload successful.");
    //       })
    //       .catch(() => {
    //         this.$toast.error("Upload failed.");
    //       });
    //   },
  
  
      removeFile(fileId) {
        const fileIndex = this.uploadedFiles.findIndex(file => file.id === fileId);
        if (fileIndex > -1) {
          // const fileName = this.uploadedFiles[fileIndex].name;
          this.uploadedFiles.splice(fileIndex, 1);
          this.$toast.success("Image removed");
        }
      },
  
      formatFileSize(bytes) {
        if (bytes === 0) return '0 Bytes';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
      },
  
    //   generateTimeOptions() {
    //     const options = [];
    //     for (let i = 0; i < 24; i++) {
    //       for (let j = 0; j < 60; j += 30) {
    //         const hour = String(i).padStart(2, '0');
    //         const minute = String(j).padStart(2, '0');
    //         const value = `${hour}:${minute}`;
    //         options.push({
    //           value: value,
    //           display: this.formatTimeForDisplay(value)
    //         });
    //       }
    //     }
    //     this.timeOptions = options;
    //   },
    //   formatTimeForDisplay(time24hr) {
    //     if (!time24hr) return '06:00'; // Default placeholder
    //     const [hour, minute] = time24hr.split(':').map(Number);
    //     const displayHour = hour % 12 === 0 ? 12 : hour % 12;
    //     return `${String(displayHour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
    //   },
      toggleTimeDropdown() {
        this.isTimeDropdownOpen = !this.isTimeDropdownOpen;
      },
    //   selectTime(time) {
    //     this.preferredInspectionTime = time;
    //     const [hour] = time.split(':').map(Number);
    //     this.preferredInspectionTimeAmPm = hour >= 12 ? 'PM' : 'AM';
    //     this.isTimeDropdownOpen = false;
    //   },
    //   setPreferredTimeAmPm(ampm) {
    //     this.preferredInspectionTimeAmPm = ampm;
    //     // Adjust the hour if needed when switching AM/PM
    //     let [hour, minute] = this.preferredInspectionTime.split(':').map(Number);
    //     if (ampm === 'PM' && hour < 12) {
    //       hour += 12;
    //     } else if (ampm === 'AM' && hour >= 12) {
    //       hour -= 12;
    //     }
    //     this.preferredInspectionTime = `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
    //   },
      handleClickOutside(event) {
        if (this.$el && !this.$el.contains(event.target)) {
          this.isTimeDropdownOpen = false;
        }
      },
      // Date input methods
      // handleDateInput(event) {
      //   let value = event.target.value.replace(/[^0-9]/g, ''); // Only allow numbers
      //   let formattedValue = '';
  
      //   if (value.length > 0) {
      //     formattedValue += value.substring(0, 2);
      //   }
      //   if (value.length > 2) {
      //     formattedValue += '-' + value.substring(2, 4);
      //   }
      //   if (value.length > 4) {
      //     formattedValue += '-' + value.substring(4, 8);
      //   }
      //   this.displayDate = formattedValue;
  
      //   // Convert to YYYY-MM-DD for internal storage/payload
      //   if (value.length === 8) {
      //     const day = value.substring(0, 2);
      //     const month = value.substring(2, 4);
      //     const year = value.substring(4, 8);
      //     this.preferredInspectionDate = `${year}-${month}-${day}`;
      //   } else {
      //     this.preferredInspectionDate = '';
      //   }
      // },
      showNativeDatePicker(event) {
        // Temporarily change type to 'date' to trigger native picker on focus
        event.target.type = 'date';
        // If there's a value, set it to the native format for the picker
        if (this.preferredInspectionDate) {
          event.target.value = this.preferredInspectionDate;
        }
      },
      hideNativeDatePicker(event) {
        // Revert type to 'text' and update display value after blur
        if (event.target.value) {
          // const [year, month, day] = event.target.value.split('-');
          // this.displayDate = `${day}-${month}-${year}`;
          this.preferredInspectionDate = event.target.value;
        } else {
          this.displayDate = '';
          this.preferredInspectionDate = '';
        }
      },
  
      // Form validation
      validateForm() {
        this.errors = {};
  
        // Title validation
        if (!this.form.title.trim()) {
          this.errors.title = 'Maintenance title is required';
        } else if (this.form.title.trim().length < 5) {
          this.errors.title = 'Title must be at least 5 characters long';
        }
  
        // // Location validation
        // if (!this.form.location) {
        //   this.errors.location = 'Please select a location';
        // }
  
        // // Property validation
        // if (!this.form.property) {
        //   this.errors.property = 'Please select a property';
        // }
  
        // Units validation
        if (this.form.selectedUnits.length === 0) {
          this.errors.selectedUnits = 'Please select at least one unit';
        }
  
        // Category validation
        // if (!this.form.category) {
        //   this.errors.category = 'Please select a maintenance category';
        // }
  
        // Priority validation
        if (!this.form.priority) {
          this.errors.priority = 'Please select a priority level';
        }
  
        // Facilities Affected validation
        if (this.form.facilitiesAffected.length === 0) {
          this.errors.facilitiesAffected = 'Please select at least one facility';
        }
  
        // Description validation
        if (!this.form.description.trim()) {
          this.errors.description = 'Description is required';
        } else if (this.form.description.trim().length < 10) {
          this.errors.description = 'Description must be at least 10 characters long';
        }  
        return Object.keys(this.errors).length === 0;
      },
  
      clearFieldError(fieldName) {
        if (this.errors[fieldName]) {
          this.$delete(this.errors, fieldName);
        }
      },
      //FETCH PROPERTIES
      async fetchFacilitiesProperty() {
        // this.isLoading = true;
        try {
          await properties.fetchPropertyFacilities().then(res => {
            // console.log("facilities", res)
            if (res.success) {
                this.facilities = res.facilities;
            }
            if (res.error) {
              this.$toast.error(res.error);
            }
  
          }).catch((err) => {
            this.loading = false;
            console.log(err);
            // this.$toast.error("please check your network and refresh the page");
          })
        } finally {
          // console.log("closed")
        }
      },
  
      // Form submission
      async submitMaintenanceRequest() {
        if (!this.validateForm()) {
          this.$toast.error("Please fill in all fields");
          return;
        }
  
        this.isSubmitting = true;
  
  
        let payload = {
  
          maintenance_title: this.form.title,
          maintenance_category_id: this.form.category,
  
          selected_units: this.form.selectedUnits,
          
          images: this.imagesUrl,
          priority: this.form.priority,
          // facilities: '',
          facilities: this.form.facilitiesAffected,
          description: this.form.description,
          property_batch: this.batch,
  
          notes: this.form.notes
  
        }
        maintenanceRequests.raiseMaintenaceRequest(JSON.stringify(payload))
          .then((res) => {
            this.isSubmitting = false;
            // console.log("maintenace request", res)
            if (res.success) {
                localStorage.setItem("maintenanceRequest", JSON.stringify(res));
                this.requestSuccessful = res;
                this.$toast.success("Maintenance request submitted successfully");
                $('#successModal').modal('show');
                this.closeModal();
                this.openVendorModal();
                this.fetchServicesCategories();
            } else {
                $('#errorModal').modal('show');
            }
          })
          .catch((error) => {
            // console.log("Error submitting data:", error);
            this.$toast.error("Error submitting");
            this.isSubmitting = false;
          })
          .finally(() => {
            // this.isSubmitting = false;
            // this.openVendorModal()
            // this
          });
      },
      removeImage(indexToRemove) {
        if (indexToRemove > -1 && indexToRemove < this.displayedFiles.length) {
          this.displayedFiles.splice(indexToRemove, 1);
        }

        if (indexToRemove > -1 && indexToRemove < this.imagesUrl.length) {
          this.imagesUrl.splice(indexToRemove, 1);
        }
      },
      async assignVendor() {
        if (this.selectedVendors.length === 0) {
          this.$toast.error('Please select at least one vendor');
          return;
        }
        if (this.vendorSearch.category == "" || this.displayDate == "" || this.displayTime == "" || this.requestSuccessful.data.id == '') {
            this.$toast.error('Fill all required fields.');
            return;
        }
        this.assigningLoader = true;
        try {
          // Simulate API call here and remove the delaylater
        //   await this.delay(1000);
            const payload = {
                vendor_id: this.user.id,
                service_id: this.vendorSearch.category,
                schedule_date: this.displayDate,
                schedule_start_time: this.displayTime,
                maintenance_id: this.requestSuccessful.data.id,
                note: this.noteVendor,
            }
            maintenanceRequests.assignRquestToVendor(JSON.stringify(payload)).then(res => {
                // console.log("assigned vendor to request", res);
                this.assigningLoader = false;
                if (res.success) {
                    this.closeVendorModal();
                    this.resetForm(); // Reset form after successful vendor assignment
                    this.$toast.success(`Successs`);
                    this.$emit('callFunction');
  
                }
            })
        //   const vendorCount = this.selectedVendors.length;
        //   const message = `${vendorCount} vendor${vendorCount !== 1 ? 's' : ''} assigned successfully!`;
  
        } catch (error) {
            this.assigningLoader = false;
            console.error('Error assigning vendor:', error);
            this.$toast.error('Error assigning vendor. Please try again.');
        }
      },
  
      // Utility methods
      resetForm() {
        this.form = {
          title: '',
          location: '',
          property: '',
          selectedUnits: [],
        //   category: '',
          priority: '',
          description: '',
          facilitiesAffected: [],
          isInspectionRequired: '',
          preferredInspectionDate: '',
        //   preferredInspectionTime: '',
        //   preferredInspectionTimeAmPm: 'AM',
          notes: ''
        };
        this.vendorForm = {
          date: '',
          time: '',
          ampm: 'AM',
          notes: ''
        };
        this.errors = {};
        this.uploadedFiles = [];
        this.selectedVendors = [];
        this.vendorSearch = {
          location: '',
          category: ''
        };
        // Reset accordions to default open state
        this.accordionOpen = {
          property: true,
          details: true,
          inspection: true,
          searchVendor: true,
          vendorInspection: true
        };
      },
  
      delay(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
      },
  
      fetchServicesCategories() {
        // let userID = this.$store.getters.getUser.id;
        maintenanceRequests.fetchServicesCategory()
          .then((data) => {
            if (data && data.success) {
  
            //   console.log("Services categories", data);
              this.form.categories = data.services_cat;
            //   console.log("Form array", this.form.categories)
            }
            if (data.error)
            {
              this.$toast.error('Service categories data not found');
            //   console.log("Service categories data not found");
            }
          })
          .catch((error) => {
            console.log("Error", error);
          })
          .finally(() => {
          });
      }
  
    },
    
  };
  </script>
  
  <style scoped>
  :root {
    --color-primary: #0033EA;
  
  }
  
  /* Reset and Base Styles */
  * {
    box-sizing: border-box;
    font-family: "Lato", sans-serif
  }
  
  /* Modal Styles */
  .modal-overlay {
    position: fixed;
    top: 70px;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
    z-index: 1000;
    overflow-y: auto;
  }
  
  .modal-sheet {
    width: 100%;
    max-width: 550px;
    min-height: 100vh;
    background: #FAFAFA;
    display: flex;
    flex-direction: column;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 1rem;
  }
  
  .modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem;
    border-bottom: 1px solid #E9EAEB;
    flex-shrink: 0;
  }
  
  .modal-title {
    font-size: 24px;
    color: #2B3352;
    font-weight: 600;
    margin: 0;
  }
  
  .modal-close {
    padding: 0.5rem;
    background: none;
    border: none;
    cursor: pointer;
  }
  
  .close-icon {
    width: 1.25rem;
    color: #2B3352;
    height: 1.25rem;
  }
  
  .modal-content {
    flex: 1;
    overflow-y: auto;
    padding: 1rem;
  }
  
  .modal-form {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    padding: 1rem;
    flex: 1;
    overflow-y: auto;
  }
  
  /* Request Summary */
  .request-summary {
    padding: 1.5 rem 1rem;
    background-color: #F5F5F5;
    flex-shrink: 0;
    line-height: 2rem;
  }
  
  .request-summary p {
    margin: 0 0 0.7rem 0;
    color: #555C74;
    font-size: 16px;
  }
  
  /* Form Fields */
  .form-field {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
  
  .field-label {
    font-size: 16px;
    font-weight: 500;
    color: #555C74;
  }
  
  .required-mark {
    color: rgb(235, 13, 13);
  }
  
  
  .field-input,
  .field-textarea {
    width: 100%;
    padding: 1rem 0.75rem;
    background: #fff;
    border: 1px solid #D5D7DA;
    border-radius: 8px;
    font-size: 0.875rem;
    color: #AAADBA;
  }
  
  .field-input:focus,
  .field-textarea:focus {
    outline: none;
  
  }
  
  .field-error {
    color: rgb(235, 13, 13);
  }
  
  
  
  .field-textarea {
    resize: none;
    min-height: 150px;
  }
  
  .error-message {
    color: rgb(235, 13, 13);
    font-size: 16px;
    margin: 0;
  }
  
  /* Accordion */
  .accordion-section {
    border: 1px solid #E9EAEB;
    border-radius: 8px;
    background: #fff;
    overflow: hidden;
  }
  
  .accordion-trigger {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem;
    background: none;
    border: none;
    cursor: pointer;
  }
  
  
  
  .accordion-title {
    font-size: 20px;
    font-weight: 600;
    color: #2B3352;
  }
  
  .accordion-chevron {
    width: 1.25rem;
    height: 1.25rem;
  }
  
  .accordion-chevron-open {
    transform: rotate(180deg);
  }
  
  .accordion-content {
    padding: 1rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
  
  /* Units Selection */
  .units-selection {
    margin-top: 0.5rem;
  }
  
  .units-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 1rem;
  }
  
  .toggle-units-btn {
    font-size: 14px;
    color: #555C74;
    background: none;
    border: none;
    cursor: pointer;
  }
  
  
  .units-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 0.5rem;
    max-height: 100px;
    overflow-x: scroll;
    box-shadow: 0 4px 6px -2px rgba(0, 0, 0, 0.3);
  }
  
  .unit-option {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem;
    color: #555C74;
    cursor: pointer;
    white-space: nowrap;
    width: 250px !important;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  
  
  
  .unit-checkbox {
    margin: 0 .5rem 0 0;
  }
  
  .unit-label {
    font-size: 14px;
  }
  
  /* Radio Group */
  .radio-group {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    color: #555C74;
  }
  
  .radio-option {
    display: flex;
    align-items: center;
    gap: 1rem;
  }
  
  .radio-input {
    margin-right: .5rem;
    cursor: pointer;
    color: #0033EA;
  }
  
  input[type="radio"] {
    accent-color: #0033ea;
  }
  
  .radio-label {
    font-size: 14px;
  }
  
  /* File Upload */
  .upload-zone {
    border: 2px dashed #CCCCCC;
    border-radius: 8px;
    padding: 2rem;
    text-align: center;
  }
  
  
  .upload-input {
    display: none;
  }
  
  .upload-button {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    background-color: #0033EA;
    color: white;
    padding: 0.75rem 1rem;
    border-radius: 8px;
    border: none;
    cursor: pointer;
    margin-bottom: 0.5rem;
  }
  
  
  
  .upload-text {
    color: #555C74;
    font-size: 16px;
    margin: 0 0 0.25rem 0;
  }
  
  .upload-hint {
    color: #B1B2B2;
    font-size: 14px;
    ;
    margin: 0;
  }
  
  /* File List */
  .file-list {
    margin-top: 1rem;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }
  
  .file-item {
    min-width: 100%;
    border-radius: 8px;
    padding: 0.75rem;
    display: flex;
    flex-direction: column;
    border: 1px solid #A4A7AE;
    justify-content: space-between;
    margin-bottom: 10px;
  }
  
  .file-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.5rem;
  }
  
  .file-icon {
    width: 2rem;
    height: 2rem;
    background-color: #fafafa;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 0.5rem;
    flex-shrink: 0;
  }
  
  .file-type-icon {
    width: 1rem;
    height: 1rem;
    color: #2B3352;
  }
  
  .file-details {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  
  .file-name {
    font-size: 16px;
    color: #2B3352;
    font-weight: 500;
    margin: 0;
    word-wrap: break-word;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 100%;
  }
  
  .file-size {
    font-size: 12px;
    color: #A4A7AE;
    margin: 0;
  }
  
  .file-actions {
    display: flex;
    align-items: flex-end;
    gap: 0.5rem;
    margin-left: auto;
  }
  
  .file-remove {
    padding: 0.25rem;
    background: none;
    border: none;
    cursor: pointer;
  }
  
  
  
  .remove-icon {
    width: 1rem;
    height: 1rem;
  }
  
  .file-success {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .progress-container {
    width: 100%;
    height: 0.5rem;
    background-color: #EBEBEB;
    border-radius: 9999px;
    overflow: hidden;
    margin-top: 0.5rem;
  }
  
  .progress-bar {
    height: 100%;
    background-color: #1FC16B;
    transition: width 1s ease-in-out;
  }
  
  
  /* Date Time Group */
  .date-time-group {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
  }
  
  /* Date Input Specific Styles */
  .date-input-wrapper {
    position: relative;
    display: flex;
    align-items: center;
  }
  
  .date-input {
    padding-left: 2.5rem;
    /* Make space for the icon */
    color: #AAADBA;
  }
  
  /* Placeholder styling for text input */
  input::placeholder {
    color: #AAADBA;
    opacity: 1;
    font-size: 16px;
    font-weight: 500;
  }
  
  /* Hide native date picker icon */
  .date-input::-webkit-calendar-picker-indicator {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: transparent;
    color: transparent;
    cursor: pointer;
  }
  
  .calendar-icon {
    position: absolute;
    left: 0.75rem;
    width: 1.25rem;
    height: 1.25rem;
    color: #AAADBA;
    pointer-events: none;
    z-index: 1;
  }
  
  /* Time Input Specific Styles */
  .time-input-group {
    position: relative;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
  
  .time-display-input {
    flex: 1;
    cursor: pointer;
    display: flex;
    align-items: center;
    color: #AAADBA;
  }
  
  .time-display-input:focus {
    outline: none;
  
  }
  
  
  .time-ampm-buttons {
    display: flex;
    border: 1px solid #AAADBA;
    border-radius: 8px;
    overflow: hidden;
  }
  
  .ampm-button {
    padding: 1rem 0.75rem;
    background-color: white;
    border: none;
    cursor: pointer;
    font-size: 0.875rem;
    color: var(--color-gray-700);
  }
  
  .ampm-button:first-child {
    border-right: 1px solid #AAADBA;
  }
  
  
  .ampm-button-active {
    background-color: #0033EA;
    color: white;
  }
  
  
  /* Time Dropdown */
  .time-dropdown {
    position: absolute;
    top: calc(100% + 0.5rem);
    /* Position below the input */
    left: 0;
    width: calc(100% - 4.5rem);
    max-height: 12rem;
    overflow-y: auto;
    background-color: #fff;
    border: 1px solid #D5D7DA;
    border-radius: 8px;
    z-index: 10000 !important;
    /* Above other modal content */
    list-style: none;
    padding: 0.25rem 0;
    margin: 0;
  }
  
  .time-dropdown-item {
    padding: 0.5rem 1rem;
    font-size: 0.875rem;
    cursor: pointer;
  }
  
  
  .time-dropdown-item-active {
    background-color: #0033EA;
    color: white;
  }
  
  .uploaded-img {
    width: 100%;
    height: 100%;
    border-radius: 2px;
    object-fit: cover;
  }
  
  /* Responsive adjustments */
  @media (max-width: 768px) {
    .date-time-group {
      grid-template-columns: 1fr;
    }
  
    .time-dropdown {
      width: 100%;
    }
  }
  
  /* Vendors Section */
  .vendors-section {
    margin: 1rem 0;
  }
  
  .section-title {
    font-weight: 600;
    color: #555C74;
    font-size: 18px;
  
    margin: 0 0 0.75rem 0;
  }
  
  .vendors-list {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }
  
  .vendor-card {
    border: 1px solid #D5D7DA;
    border-radius: 8px;
    padding: 1rem;
    cursor: pointer;
  }
  
  
  
  .vendor-selected {
    border-color: #D5D7DA;
    background-color: rgba(37, 99, 235, 0.05);
  }
  
  .vendor-content {
    width: 100%;
  }
  
  .vendor-header {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 0.5rem;
  
  }
  
  .vendor-checkbox {
    margin: 0;
  }
  
  .vendor-name {
    font-weight: 600;
    color: #555C74;
    font-size: 16px;
    margin: 0;
    flex: 1;
  }
  
  .vendor-status {
    background-color: #ECFDF3;
    color: #067647;
    font-size: 14px;
    padding: 0.25rem 0.7rem;
    border-radius: 100px;
    border: 1px solid #ABEFC6;
  }
  
  .vendor-details {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    margin-bottom: 0.5rem;
    font-size: 14px;
    color: #717680;
  }
  
  .vendor-detail {
    display: flex;
    align-items: center;
    gap: 0.25rem;
  }
  
  .detail-icon {
    width: 1rem;
    height: 1rem;
  }
  
  .star-icon {
    color: #fbbf24;
  }
  
  .profile-btn {
    color: var(--color-primary);
    background: none;
    border: none;
    cursor: pointer;
    font-size: 0.875rem;
    font-weight: 500;
    transition: color var(--transition-fast);
  }
  
  .no-vendor {
    font-family: Lato;
    font-size: 15px;
    margin-top: 10px;
    color: #000000;
  }
  
  /* Form Actions */
  .form-actions {
    display: flex;
    gap: 0.75rem;
    padding-top: 1.5rem;
    border-top: 1px solid #ccc;
    margin-top: auto;
    flex-shrink: 0;
  }
  
  .form-actions .btn {
    flex: 1;
  }
  
  /* Button  */
  .btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    padding: 0.75rem 1rem;
    border-radius: 8px;
    font-weight: 500;
    font-size: 0.875rem;
    cursor: pointer;
    background: #0033EA;
    border: none;
    color: #fff;
    font-weight: 600;
    text-decoration: none;
  }
  
  .btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  
  .btn-primary {
    background-color: #0033EA;
    border-radius: 8px;
    color: white;
  }
  
  
  .btn-secondary {
    background-color: white;
    color: #414651;
    border: 1px solid #D5D7DA;
  }

  .ellipsis2 {
    width: 125px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  
  
  /* Loading Spinner */
  .loading-spinner {
    width: 1rem;
    height: 1rem;
    animation: spin 1s linear infinite;
  }
  
  .spinner-track {
    opacity: 0.25;
  }
  
  .spinner-path {
    opacity: 0.75;
  }
  
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
  
    to {
      transform: rotate(360deg);
    }
  }
  
  /* Modal Transitions */
  .modal-enter-active,
  .modal-leave-active {
    transition: opacity var(--transition-normal);
  }
  
  .modal-enter-active .modal-sheet,
  .modal-leave-active .modal-sheet {
    transition: transform var(--transition-normal);
  }
  
  .modal-enter,
  .modal-leave-to {
    opacity: 0;
  }
  
  .modal-enter .modal-sheet,
  .modal-leave-to .modal-sheet {
    transform: translateX(100%);
  }
  
  /* Responsive Design */
  @media (max-width: 768px) {
    .modal-sheet {
      max-width: 100%;
    }
  
    .units-grid {
      grid-template-columns: 1fr;
    }
  
    .vendor-details {
      flex-direction: column;
      gap: 0.5rem;
    }
  
    .form-actions {
      flex-direction: column;
    }
  
    .form-actions .btn {
      flex: none;
    }
  
    .file-list {
      grid-template-columns: 1fr;
    }
  
    .date-time-group {
      grid-template-columns: 1fr;
    }
  }
  
  @media (max-width: 640px) {
    .modal-form {
      padding: 0.5rem;
    }
  }
  
  /* Focus Management */
  .modal-overlay:focus {
    outline: none;
  }
  
  /* High Contrast Mode Support */
  @media (prefers-contrast: high) {
  
    .field-input:focus,
    .field-textarea:focus {
      outline: 2px solid;
    }
  
    .btn:focus {
      outline: 2px solid;
      outline-offset: 2px;
    }
  }
  
  /* Reduced Motion Support */
  @media (prefers-reduced-motion: reduce) {
  
    *,
    *::before,
    *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
    }
  }
  
  /* Print Styles */
  @media print {
    .modal-overlay {
      display: none;
    }
  }
  </style>
  